import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const FixedPopover = ({ 
    anchorEl, 
    onClose, 
    children 
  }: { 
    anchorEl: HTMLElement | null; 
    onClose: () => void; 
    children?: React.ReactNode 
  }) => {
    const ref = useRef<HTMLDivElement>(null);
  
    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (
          ref.current && 
          !ref.current.contains(event.target as Node) && 
          anchorEl && 
          !anchorEl.contains(event.target as Node)
        ) {
          onClose();
        }
      };
      window.addEventListener("mousedown", handleClickOutside);
      window.addEventListener("resize", onClose);
      return () => {
        window.removeEventListener("mousedown", handleClickOutside);
        window.removeEventListener("resize", onClose);
      };
    }, [onClose, anchorEl]);
  
    if (!anchorEl) return null;
  
    const rect = anchorEl.getBoundingClientRect();
    const top = rect.bottom + window.scrollY;
    const left = rect.left + window.scrollX;
  
    return createPortal(
      <div 
        ref={ref}
        className="popover"
        style={{ top: `${top}px`, left: `${left}px`, width: '252px' }}
      >
        {children}
      </div>,
      document.body
    );
  };

export default FixedPopover;